import { app } from '../../../bootstrap/core';
import heroComponent from './hero.component';
import { backgroundCover } from './hero.directive';

app.component('hero', heroComponent);
app.directive('backgroundCover', backgroundCover);
